import {ComponentLanguageContentBase} from '../database-models/component-language-content-base';
import {LanguageContentKeyBase} from '../database-models/language-content-key-base';
import {LanguageContentBase} from '../database-models/language-content-base';
//Generated Imports
export class ComponentLanguageContent extends ComponentLanguageContentBase 
{




//#region Generated Reference Properties
//#region languageContentKey Prop
languageContentKey : LanguageContentKeyBase;
//#endregion languageContentKey Prop
//#region languageContent Prop
languageContent : LanguageContentBase;
//#endregion languageContent Prop

//#endregion Generated Reference Properties

























}